import decodeFilterBarPlacement, {
	encodeFilterBarPlacement,
	FilterBarPlacement,
	nextFilterBarPlacement
} from "~/helpers/grid/filterBarPlacement";
import useUserAppSettingMutations from "~/hooks/mutations/useUserAppSettingMutations";
import { useAppSelector } from "~/hooks/reduxHooks";
import { useGetUserAppSettingsQuery } from "~/services/endpoints/apiEndpoints";

const SETTINGS_GROUP = "grid";
const SETTINGS_NAME = "filterBarPlacement";

export interface UseFilterBarPlacementReturn {
	cyclePlacement: () => void;
	placement: FilterBarPlacement;
}

const useFilterBarPlacement = (): UseFilterBarPlacementReturn => {
	const email = useAppSelector((state) => state.settings.email);
	const { updateUserAppSetting } = useUserAppSettingMutations();
	const { data } = useGetUserAppSettingsQuery(
		{ first: 1, where: { emailAddress: { eq: email }, group: { eq: SETTINGS_GROUP }, name: { eq: SETTINGS_NAME } } },
		{ skip: !email }
	);

	const placement = decodeFilterBarPlacement(data?.userAppSettings?.nodes?.[0]?.base64Settings);

	const cyclePlacement = () => {
		if (!email) return;
		const next = nextFilterBarPlacement(placement);
		updateUserAppSetting({
			base64Settings: encodeFilterBarPlacement(next),
			emailAddress: email,
			group: SETTINGS_GROUP,
			name: SETTINGS_NAME
		});
	};

	return { cyclePlacement, placement };
};

export default useFilterBarPlacement;
